// NOTE: This was ported from modules/clean/uuid from metaserver
// but uses window.crypto
const BYTE_TO_HEX = (() => {
    let j;
    let i;
    const result = [];
    for (j = 0x00, i = j; j <= 0xff; j++, i = j) {
        result.push((i + 0x100).toString(16).substr(1));
    }
    return result;
})();
function bytesToHex(bytes) {
    return bytes.map((byte) => BYTE_TO_HEX[byte]).join('');
}
function getRandomBytes() {
    const bytes = new Uint8Array(16);
    // In tests you need to call mockCrypto from
    // js/tests/lib/mock_crypto.ts
    window.crypto.getRandomValues(bytes);
    return bytes;
}
export function v4() {
    const bytes = getRandomBytes();
    // According to the RFC:
    //
    // 1. The 7th byte should be in the form 0b0100XXXX, meaning the
    //    13th hexadecimal character will be "4".
    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    // 2. The 9th byte should be in the form 0b10XXXXXX, meaning the
    //    17th hexadecimal character will be "8", "9", "a", or "b".
    bytes[8] = (bytes[8] & 0x3f) | 0x80;
    // Because Uint8Array in IE11 doesn't support `slice`
    const hexArray = Array.prototype.slice.call(bytes);
    /**
     * Convert an array of 16 bytes into a hexadecimal string of the form
     * "xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx"
     */
    return [
        hexArray.slice(0, 4),
        hexArray.slice(4, 6),
        hexArray.slice(6, 8),
        hexArray.slice(8, 10),
        hexArray.slice(10, 16),
    ]
        .map(bytesToHex)
        .join('-');
}
//# sourceMappingURL=uuid.preenvesnextjs.map
